export const FORMAT_DATE = 'MM/DD/YYYY';
export const FORMAT_DATETIME = 'MM/DD/YYYY HH:mm';
export const FORMAT_TIME = 'h:mm A';
export const ISO_DATE_FORMAT = 'YYYY-MM-DD';
export const ISO_DATETIME_FORMAT = 'YYYY-MM-DD HH:mm';
export const SHORT_DATE_FORMAT = 'YYYY/MM/DD';
